import { Box, useMediaQuery, useTheme } from "@mui/material";
import { Suspense, lazy, useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SectionHeader, Spinner } from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogContext";
import { RootState } from "../../../slices/Store";
import { useTutorialContext } from "../../tutorialModule/TutorialContext";
import TutorialWrapper from "../../tutorialModule/TutorialWrapper";
import ProjectDetailAddress from "../Shared/ProjectDetailAddress";
import ProjectDetailConstructorSection from "../Shared/ProjectDetailConstructorSection";
import ProjectDetailFolders from "../Shared/ProjectDetailFolders";
import ProjectDetailInfo from "../Shared/ProjectDetailInfo";
import ProjectDetailInvalidDataAndVisibility from "../Shared/ProjectDetailInvalidDataAndVisibility";
import ProjectDetailNotes from "../Shared/ProjectDetailNotes";
import ProjectDetailSales from "../Shared/ProjectDetailSales";
import ProjectDetailMobileHeader from "./ProjectDetailMobileHeader";
import ProjectDetailMobilePhotos from "./ProjectDetailMobilePhotos";
import ProjectDetailMobileSms from "./ProjectDetailMobileSms";

const ProjectDetailMap = lazy(() => import("../Shared/ProjectDetailMap"));

// updated
export default function ProjectDetailMobileDialog(props: {
    selectedFollowUpId?: number;
    openSales?: boolean;
}) {
    const navigate = useNavigate();
    const { closeDialog } = useContext(DialogContext);
    const { activeStep } = useTutorialContext();

    const projectDetailState = useSelector(
        (state: RootState) => state.projectDetail
    );

    const theme = useTheme();
    const isSmallOrDownScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const scrollToSectionIfNeeded = () => {
        if (props.openSales) {
            const section = document.querySelector("#sales_section");
            if (section) {
                section.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    };

    useEffect(() => {
        scrollToSectionIfNeeded();
    }, []);

    if (projectDetailState.fetchingProjectDetail) {
        return <Spinner />;
    }

    const handleNavigateToMap = () => {
        if (activeStep === "mobile-signup-9") {
            closeDialog();
            navigate("/map");
        }
    };

    return (
        <Box sx={{ bgcolor: "background.default" }}>
            <ProjectDetailMobileHeader />

            <Box sx={{ p: 2 }}>
                <TutorialWrapper
                    steps={["mobile-signup-8", "mobile-signup-9"]}
                    onNextStep={handleNavigateToMap}
                    forDialog={true}
                    position={isSmallOrDownScreen ? "bottom" : "left"}
                    renderChildren={(wa, control) => (
                        <Box {...control}>
                            <ProjectDetailMobilePhotos />
                        </Box>
                    )}
                />

                <ProjectDetailConstructorSection />

                {/*<ProjectDetailRequirements/>*/}

                <ProjectDetailAddress />

                <ProjectDetailInfo />

                <ProjectDetailInvalidDataAndVisibility />

                <ProjectDetailFolders />

                <Box id="sales_section">
                    <SectionHeader title="فرایند های فروش" />
                    <ProjectDetailSales />
                </Box>

                <Box>
                    <SectionHeader title="یادداشت ها" />
                    <ProjectDetailNotes />
                </Box>

                <Box>
                    <SectionHeader title="موقعیت پروژه" />
                    <Suspense fallback={<Spinner />}>
                        <ProjectDetailMap />
                    </Suspense>
                </Box>

                <ProjectDetailMobileSms
                    projects={[projectDetailState.projectDetail]}
                />
            </Box>
        </Box>
    );
}
